import { render, staticRenderFns } from "./ContentDialog.vue?vue&type=template&id=279c3028&"
import script from "./ContentDialog.vue?vue&type=script&lang=js&"
export * from "./ContentDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContentDialog.vue?vue&type=style&index=0&id=279c3028&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports